module.exports = __webpack_public_path__ + "static/best-sellers-b7e12214e590b6774873db0bd2b4f621.jpg";